<!-- Do not change this file. -->
<template>
  <div class="d-flex flex-column h-100">
    <div>
      <TheHeader />
      <TheNavbar />
    </div>
    <div class="flex-grow-1 py-3 angled-stripes" role="main">
      <div class="container" v-show="rerouteUser">
        <div class="d-flex row justify-content-center">
          <div class="col-12 col-sm-8 col-md-6">
            <CustomAlert type="primary" title="Welcome!" class="rounded-5"
              >Let's begin the competition by joining a house! Click below to
              get started.
              <div class="mt-3"></div>
              <div class="text-center">
                <RouterButton
                  to="Home"
                  label="Join a House!"
                  icon="arrow-right"
                />
              </div>
            </CustomAlert>
          </div>
        </div>
      </div>
      <SessionHandler v-show="!rerouteUser" />
    </div>
    <TheFooter />
  </div>
</template>

<script>
/* Do not change this file. */

import TheHeader from "@/components/core/TheHeader.vue";
import TheFooter from "@/components/core/TheFooter.vue";
import TheNavbar from "@/components/core/TheNavbar.vue";
import SessionHandler from "@/components/core/SessionHandler.vue";
import RouterButton from "./components/activity/RouterButton.vue";

import config from "@/data/config";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    TheHeader,
    TheNavbar,
    TheFooter,
    SessionHandler,
    RouterButton
  },
  data() {
    return {
      backgroundClass: config.appStyle.backgroundClass
    };
  },
  computed: {
    ...mapGetters(["getCourseId"]),
    rerouteUser() {
      if (
        this.$route.name !== "Achievements" &&
        this.$route.name !== "Home" &&
        this.$route.name !== "Leaderboard" &&
        this.$route.name !== "FAQ"
      ) {
        return false;
      }

      return this.getCourseId;
    }
  },
  methods: {
    ...mapActions(["setHash"])
  },
  created() {
    this.setHash(window.location.hash);
  }
};
</script>
